
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Pouvez-vous encore être visible sur Internet ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Pouvez-vous encore être visible sur Internet ? Quelles sont les solutions de communication pour dépasser la concurrence ? Cet article vous livre conseils et astuces.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Pouvez-vous encore être visible sur Internet ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Pouvez-vous encore être visible sur Internet ? Quelles sont les solutions de communication pour dépasser la concurrence ? Cet article vous livre conseils et astuces.",
        },
      ],
    };
  },
};
